import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Stat = ({ label, value, sub, testId, accent = 'text-foreground' }) => (
  <div className="flex flex-col items-center px-4 py-2 rounded-md bg-background/60 border border-border min-w-[110px]" data-testid={testId}>
    <span className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</span>
    <span className={`text-lg font-bold leading-tight ${accent}`}>{value}</span>
    {sub && <span className="text-[11px] text-muted-foreground">{sub}</span>}
  </div>
);

export const SeasonRecapCard = ({ eventId, users = [] }) => {
  const [recap, setRecap] = useState(null);

  useEffect(() => {
    axios.get(`${API}/events/${eventId}/recap`).then(r => setRecap(r.data)).catch(() => setRecap(null));
  }, [eventId]);

  if (!recap) return null;

  const { wins, losses, ties, games_played, games_total, tickets_used, parking_used, top_partners } = recap;
  const decided = wins + losses + ties;
  const record = ties > 0 ? `${wins}-${losses}-${ties}` : `${wins}-${losses}`;
  const pct = decided ? ((wins / decided) * 100).toFixed(1) : '0.0';
  const recordAccent = wins > losses ? 'text-green-400' : wins < losses ? 'text-red-400' : 'text-amber-400';
  const nameFor = (pid) => users.find(u => u.partner_id === pid)?.name || pid;

  return (
    <div className="mb-3 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3" data-testid={`season-recap-${eventId}`}>
      <h4 className="text-sm font-semibold mb-2 text-amber-300">🏁 Season Recap</h4>
      <div className="flex flex-wrap justify-center gap-2">
        <Stat label="Final Record" value={record} sub={`${pct}% win`} accent={recordAccent} testId={`recap-record-${eventId}`} />
        <Stat label="Games Played" value={`${games_played}/${games_total}`} testId={`recap-games-${eventId}`} />
        <Stat label="Tickets Used" value={tickets_used} testId={`recap-tickets-${eventId}`} />
        <Stat label="Parking Used" value={parking_used} testId={`recap-parking-${eventId}`} />
      </div>
      {top_partners?.length > 0 && (
        <div className="flex flex-wrap justify-center gap-2 mt-2 text-xs text-muted-foreground" data-testid={`recap-partners-${eventId}`}>
          {top_partners.map(p => (
            <span key={p.partner_id} className="px-2 py-0.5 rounded-full border border-border">
              {nameFor(p.partner_id)}: <b className="text-foreground">{p.tickets}</b> tix
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
